import { SlideType } from './enums';
import { SlideMetadata, VisibleSlideMetadata } from './types';

export const computeVisibleSlideData = (
    slideMetadata: Array<SlideMetadata<unknown>>,
    availableSpace: number,
    skinnySlideWidth: number,
    regularSlideWidth: number,
    currentVisibleSlideMetaData?: VisibleSlideMetadata
): VisibleSlideMetadata => {
    let widthOfCurrentlyVisibleSlides = currentVisibleSlideMetaData?.widthOfCurrentlyVisibleSlides || 0;
    let slidesShowing = currentVisibleSlideMetaData?.slidesShowing || 0;

    for (const metadata of slideMetadata) {
        const newWidth =
            widthOfCurrentlyVisibleSlides +
            (metadata.type !== SlideType.DATE && metadata.type !== SlideType.PLAYOFF_ROUND
                ? regularSlideWidth
                : skinnySlideWidth);

        if (newWidth > availableSpace) {
            break;
        }

        widthOfCurrentlyVisibleSlides = newWidth;
        slidesShowing++;
    }

    return {
        widthOfCurrentlyVisibleSlides,
        slidesShowing,
    };
};
